// @ts-nocheck
import { fetchData } from '../utils';

export async function classifiedKeywords(
    filter,
    vertical,
    baseUrl,
): Promise<MappedKeyWords | {}> {
    let searchQuery = filter['q'] as string;
    let formattedVertical = vertical.toUpperCase();

    let hasClassifiedFilters = isClassified(filter, formattedVertical);

    if (searchQuery && !hasClassifiedFilters) {
        return classifySearchQuery(searchQuery, formattedVertical, baseUrl);
    } else return {};
}

function isClassified(filter, vertical) {
    switch (vertical) {
        case 'REALESTATE':
            return 'location' in filter;
        case 'CAR':
            return ['make', 'model'].some((keyword) => keyword in filter);
        case 'BAP':
        case 'BAP_WEBSTORE':
            return ['category', 'sub_category', 'product_category'].some(
                (keyword) => keyword in filter,
            );
        case 'JOB':
            return 'occupation' in filter;
        case 'BOAT':
            return 'make' in filter;
        default:
            return true; //Treat unsupported verticals as already classified to avoid calling the classifier service
    }
}

async function classifySearchQuery(
    query: string,
    vertical: string,
    baseUrl: string,
) {
    try {
        let searchQueryClassifierUrl = buildSearchQueryClassifierUrl(
            query,
            vertical,
            baseUrl,
        );
        let data = await fetchData(searchQueryClassifierUrl);

        if (data['classifications'] && data['classifications'][0]) {
            return mapper(vertical, data['classifications'][0]);
        }

        console.warn(
            `No classification for vertical ${vertical} and search query ${query}`,
        );
        return {};
    } catch (err) {
        console.error(err);
        return {};
    }
}

function buildSearchQueryClassifierUrl(
    query: string,
    vertical: string,
    baseUrl: string,
) {
    return `${baseUrl}/search-query-classifier?query=${query}&vertical=${vertical}`;
}

function mapper(
    vertical: string,
    classification: Classification,
): MappedKeyWords {
    switch (vertical) {
        case 'REALESTATE':
            return mappedKeyWordObjects(classification, realEstateKeyWords, 3);
        case 'CAR':
            return mappedKeyWordObjects(classification, carKeyWords);
        case 'BAP':
        case 'BAP_WEBSTORE':
            return mappedKeyWordObjects(classification, bapKeyWords, 3);
        case 'JOB':
            return mappedKeyWordObjects(classification, jobKeyWords);
        case 'BOAT':
            return mappedKeyWordObjects(classification, boatKeyWords, 1);
        default:
            return {};
    }
}

function mappedKeyWordObjects(
    classification: Classification,
    keyWordsArray: string[],
    size: number = 2,
) {
    let classificationValues = Object.values(classification);
    let mappedPair = classificationValues
        .slice(0, size)
        .reduce((result: { [index: string]: any }, field, index) => {
            result[keyWordsArray[index]] = field.toString();
            return result;
        }, {});
    return mappedPair;
}

type Classification = {
    level0: number;
    level1: number;
    level2?: number;
};

export type MappedKeyWords = Record<string, string>;

const realEstateKeyWords = [
    'no-sno-finn-region',
    'no-sno-finn-municipality',
    'no-sno-finn-city',
];
const carKeyWords = ['no-sno-finn-car_make', 'no-sno-finn-car_model'];
const bapKeyWords = [
    'no-sno-finn-bap_main_category',
    'no-sno-finn-bap_sub_category',
    'no-sno-finn-bap_product_category',
];
const jobKeyWords = [
    'no-sno-finn-occupation_main',
    'no-sno-finn-occupation_sub',
];
const boatKeyWords = ['no-sno-finn-boat_make'];
